import { type ReactNode } from 'react';
import { ChevronRightIcon } from '@zep-us/zus-icons';
import { cn } from '@/utils/tailwind.util';
interface CTAButtonRightSlotProps {
  /**
   * 평소(non-hover)에 노출할 배지(예: NewChip).
   * hover 시에는 ChevronRightIcon이 자리를 차지하면서 배지를 가린다.
   */
  badge?: ReactNode;
}

/**
 * CTAButtonRightSlot
 *
 * @description
 * 우측 칼럼 CTA 버튼의 공통 rightSlot. 평소에는 비어 있다가(또는 배지를 노출하다가),
 * 부모 Button에 `group` 클래스가 적용된 상태에서 hover 시 우측 끝에 `ChevronRightIcon`을
 * 표시한다. 시각적 유도를 위한 일관된 어포던스를 제공한다.
 *
 * 사용 예:
 * ```tsx
 * <Button className="group ..." rightSlot={<CTAButtonRightSlot />}>...</Button>
 * <Button className="group ..." rightSlot={<CTAButtonRightSlot badge={<NewChip />} />}>...</Button>
 * ```
 */
export const CTAButtonRightSlot = ({
  badge
}: CTAButtonRightSlotProps) => {
  const hasBadge = Boolean(badge);
  return <span className="ml-auto inline-flex items-center" data-sentry-component="CTAButtonRightSlot" data-sentry-source-file="CTAButtonRightSlot.tsx">
      {hasBadge ? <span className="group-hover:hidden">{badge}</span> : null}
      <ChevronRightIcon size="sm" className={cn('transition-opacity duration-150', hasBadge ? 'hidden group-hover:inline-block' : 'opacity-0 group-hover:opacity-100')} data-sentry-element="ChevronRightIcon" data-sentry-source-file="CTAButtonRightSlot.tsx" />
    </span>;
};